import OperationCenterErrorCard, {
  ErrorType,
} from '../../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';

export const NoResultPage = () => {
  return (
    <div>
      <OperationCenterErrorCard errorType={ErrorType.NO_RESULT} />
    </div>
  );
};
